import { SDKError } from '../utils/errors.js';
import { ButtonWidget } from './ButtonWidget.js';
import { ChangelogWidget } from './ChangelogWidget.js';
import { InlineWidget } from './InlineWidget.js';
import { MessengerWidget } from './MessengerWidget.js';
import { SurveyWidget } from './SurveyWidget.js';
import { TabWidget } from './TabWidget.js';

export class WidgetFactory {
	static widgets = new Map([
		['button', ButtonWidget],
		['tab', TabWidget],
		['inline', InlineWidget],
		['survey', SurveyWidget],
		['messenger', MessengerWidget],
		['changelog', ChangelogWidget],
	]);

	static register(type, WidgetClass) {
		if (typeof type !== 'string' || !type.trim()) {
			throw new SDKError('Widget type must be a non-empty string');
		}

		if (typeof WidgetClass !== 'function') {
			throw new SDKError('Widget class must be a constructor function');
		}

		this.widgets.set(type, WidgetClass);
	}

	static create(type, options = {}) {
		const WidgetClass = this.widgets.get(type);

		if (!WidgetClass) {
			const availableTypes = Array.from(this.widgets.keys()).join(', ');
			throw new SDKError(
				`Unknown widget type: ${type}. Available types: ${availableTypes}`
			);
		}

		try {
			return new WidgetClass(options);
		} catch (error) {
			throw new SDKError(
				`Failed to create widget of type '${type}': ${error.message}`,
				error
			);
		}
	}

	static getAvailableTypes() {
		return Array.from(this.widgets.keys());
	}

	static isTypeRegistered(type) {
		return this.widgets.has(type);
	}

	static unregister(type) {
		return this.widgets.delete(type);
	}

	static clear() {
		this.widgets.clear();
	}

	static getWidgetClass(type) {
		return this.widgets.get(type);
	}
}
